export default "/images/vendor/flag-icon-css/flags/4x3/at.svg?1281f451a103684e9248610c8725fecc";